/**
 * Auth0 + API configuration for the add-in.
 *
 * ───────────────────────────────────────────────────────────────────────────
 * SETUP: fill in the three Auth0 values below after creating your tenant.
 *   1. Create a free Auth0 tenant at https://auth0.com.
 *   2. Applications → Create Application → "Single Page Web Application".
 *        - Allowed Callback URLs:  https://localhost:3000/auth-end.html
 *          (add your production URL too, e.g. https://app.landis.dev/auth-end.html)
 *        - Allowed Web Origins:    https://localhost:3000  (+ your prod origin)
 *      Copy the Domain and Client ID into `domain` / `clientId` below.
 *   3. APIs → Create API. Set an Identifier (e.g. https://api.sheetybanks.com).
 *      Put that identifier into `audience` below AND into the API's
 *      AUTH0_AUDIENCE env var. Set AUTH0_DOMAIN to the same `domain`.
 * ───────────────────────────────────────────────────────────────────────────
 */
export const authConfig = {
  domain: "dev-cfs8ze7qw1uk7hpx.us.auth0.com",
  clientId: "zzsTFSLV6pMld7OJajQA8MfFDbzXOhXs",
  audience: "https://api.sheetybanks.com",
  scope: "openid profile email",
};

/** True until the placeholders above are replaced — used to show a setup hint. */
export const isAuthConfigured = (): boolean =>
  !authConfig.domain.startsWith("YOUR_") && !authConfig.clientId.startsWith("YOUR_");

/** The add-in's own origin (https://localhost:3000 in dev, your deployed origin in prod). */
export const addinOrigin = (): string => window.location.origin;

/** Auth0 redirect target — the page that hands the auth code back to the task pane. */
export const redirectUri = (): string => `${addinOrigin()}/auth-end.html`;

/**
 * Base URL of the SheetyBanks API.
 * Dev: the add-in is served from :3000 and the API runs on :3001.
 * Prod: the API serves the add-in from the same origin, so use a relative path.
 */
export const apiBaseUrl = (): string =>
  addinOrigin().includes("localhost:3000") ? "https://localhost:3001/api" : `${addinOrigin()}/api`;
